import React from 'react';
import Header from '../components/Header';
import HeroSlider from '../components/HeroSlider';
import About from '../components/About';
import Services from '../components/Services';
import Stats from '../components/Stats';
import Testimonials from '../components/Testimonials';
import Team from '../components/Team';
import Footer from '../components/Footer';

export default function Home() {
  return (
    <>
      <Header transparent />
      <HeroSlider />
      <About />
      <Services />
      <Stats />
      <Team />
      <Testimonials />
      <Footer />
    </>
  );
}
